export function sum(array: number[]) {
  return array.reduce((prev, current) => {
    return prev + current;
  });
}

export const getRandomId = () => Number(String(Math.random()).split(".")[1]);
